import { Box, Chip, Stack } from "@mui/material";
import type { Milestone } from "@/api/types";

const COLOR: Record<Milestone["status"], "success" | "warning" | "error" | "default"> = {
  green: "success",
  yellow: "warning",
  red: "error",
  gray: "default",
};

const ICON: Record<NonNullable<Milestone["icon"]>, string> = {
  check: "✓",
  dot: "•",
  x: "✕",
};

export function MilestoneBar({ milestones }: { milestones: Milestone[] }) {
  return (
    <Stack direction="row" spacing={1}
           sx={{ gap: 1, alignItems: "center", flexWrap: "wrap" }}>
      {milestones.map((m, i) => (
        <Box key={m.slug} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Chip
            size="small"
            data-status={m.status}
            label={
              <span>
                <span>{m.label}</span>
                {m.icon ? <span aria-hidden="true"> {ICON[m.icon]}</span> : null}
              </span>
            }
            color={COLOR[m.status]}
            variant={m.status === "gray" ? "outlined" : "filled"}
          />
          {i < milestones.length - 1 && (
            <Box sx={{ color: "text.disabled", fontSize: 14 }}>›</Box>
          )}
        </Box>
      ))}
    </Stack>
  );
}
